export default __webpack_public_path__ + "static/media/15.0e844983.png";